module.exports = __webpack_public_path__ + "img/iphone-screen@2x.6a2a27b9.jpg";